import { useEffect, useState } from "react";
import "./index.css";
import { Timer } from "./Timer";
import { DailyImage } from "./DailyImage";
import { ChaosMode } from "./ChaosMode";
import { TestPage } from "./TestPage";
import { dailyEffect } from "./effects";
import { isBirthdayToday } from "./utils/date";

function usePathname() {
  const [path, setPath] = useState<string>(() =>
    typeof window === "undefined" ? "/" : window.location.pathname,
  );
  useEffect(() => {
    const onPop = () => setPath(window.location.pathname);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return path;
}

export function App() {
  const path = usePathname();
  const [now, setNow] = useState<Date>(() => new Date());

  // Re-evaluate every minute so the page flips into chaos mode automatically
  // when midnight rolls into Nov 28, and rotates the daily effect/image at
  // the date change without needing a refresh.
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);

  if (path === "/test") {
    return <TestPage />;
  }

  const isBirthday = isBirthdayToday(now);
  const effect = dailyEffect(now);
  const Effect = effect.Component;

  if (isBirthday) {
    return (
      <main className="app">
        <ChaosMode />
      </main>
    );
  }

  return (
    <main className="app">
      <Effect />

      <header className="app-header">
        <div className="bow-mark" aria-hidden>🎀</div>
        <p className="tagline">
          counting down to <span className="tagline-name">her</span> day
        </p>
      </header>

      <section className="app-main">
        <Timer onReached={() => setNow(new Date())} />
        <p className="timer-message">
          november 28 | the best day of the year ♡
        </p>
      </section>

      <footer className="app-footer">
        <div className="app-footer-left">
          <span className="effect-badge" title={`today's effect: ${effect.name}`}>
            <span className="effect-badge-dot" />
            <span className="effect-badge-name">
              today's vibe: {effect.emoji} {effect.name}
            </span>
          </span>
        </div>
        <div className="app-footer-right">
          <DailyImage />
        </div>
      </footer>

      <a className="test-corner-link" href="/test" aria-label="effect playground">
        ✦ playground
      </a>
    </main>
  );
}

export default App;
